import SpotifyPlayerComponent from '@wix/thunderbolt-elements/src/components/SpotifyPlayer/viewer/SpotifyPlayer';
import SpotifyPlayerController from '@wix/thunderbolt-elements/src/components/SpotifyPlayer/viewer/SpotifyPlayer.controller';


const SpotifyPlayer = {
  component: SpotifyPlayerComponent,
  controller: SpotifyPlayerController
};


export const components = {
  ['SpotifyPlayer']: SpotifyPlayer
};

